<template>
    <div>
        <div>
        <b-modal :title="`${my_title} আবেদন বিস্তারিত `" no-close-on-backdrop hide-footer size="xl"  v-model="largeModal" >
            <div class="text-right">
                <button @click="printDoc('printDiv')"  class="btn btn-info"><i class="fa fa-print"></i>Print</button>
            </div>

            <div>
                <step-progress :active-color="'green'" :passive-color="'#888'" :passive-thickness="5" :line-thickness="5" :active-thickness="5"  :steps="mySteps" :current-step="currentStep" icon-class="fa fa-check"></step-progress>
            </div>
            <div id="printDiv" class="container" style="margin-left: 20px;font-size: 18px">
                <h3>2555</h3>
                <div style="justify-content: center" class="row">
                    <div class="col-md-1">
                        <img style="height: 100px;width: 100px" src="@/assets/images/paorosheba-logo-chandpur.png"/>
                    </div>
                    <div class="col-md-0"></div>
                    <div style="text-align: center;font-family: 'Hind Siliguri Light'" class="col-md-3">
                        <h4>চাঁদপুর পৌরসভা কার্যালয়</h4>
                        <h5 style="text-align: center">চাঁদপুর,বাংলাদেশ</h5>
                    </div>
                </div>
                <div class="row">
                    <div style="font-family: Hind Siliguri Light" class="col-md-3">
                        <h4>বরাবর,</h4>
                        <div style="margin-left: 50px;">
                            <h4>মেয়র</h4>
                            <h4>চাঁদপুর পৌরসভা</h4>
                            <h4>চাঁদপুর </h4>
                        </div>
                    </div>
                    <div style="font-family: Hind Siliguri Light;margin-left: auto" class="col-md-3">
                        <h4>ফরম নম্বর:12345678</h4>
                        <h5>মূল্যঃ <span>{{ data.service.price }}</span></h5>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-6" style="margin-top:10px;margin-bottom: 40px; text-align: center">
                        <span style="padding:5px;font-family: 'Hind Siliguri Light';font-size: 20px;border: 2px solid black;background-color: silver">পানির লাইন সংযোগ/ওয়াস/সাইজ পরিবর্তনের আবেদন ফরম</span>

                    </div>
                    <div style="margin-left: auto" class="col-md-3">
                        <img style="height: 150px;width: 150px" class="img-fluid" :src="$axios.defaults.baseURL+'/application/'+data.applicant_picture"/>
                    </div>
                </div>
                <form  style="font-family: 'Hind Siliguri Light';margin-top:10px;" @submit.prevent="addApplication">
                    <!--                <div  class="form-group row">-->
                    <!--                    <label  class="col-sm-2 col-form-label">নাম</label>-->
                    <!--                    <label  class="col-sm-3 col-form-label">: {{data.user.name}}</label>-->
                    <!--                    <div class="col-sm-2"></div>-->
                    <!--                    <label  class="col-sm-2 col-form-label">জন্ম তারিখ</label>-->
                    <!--                    <label  class="col-sm-3 col-form-label">: {{data.user.birthday}}</label>-->
                    <!--                </div>-->
                    <!--                <div  class="form-group row">-->
                    <!--                    <label  class="col-sm-2 col-form-label">মোবাইল নম্বর</label>-->
                    <!--                    <label  class="col-sm-3 col-form-label">: {{data.user.mobile_number}}</label>-->
                    <!--                    <div class="col-sm-2"></div>-->
                    <!--                    <label  class="col-sm-2 col-form-label">এন.আই.ডি নম্বর</label>-->
                    <!--                    <label  class="col-sm-3 col-form-label">: {{data.user.nid}}</label>-->
                    <!--                </div>-->
                    <div  class="form-group row">
                        <label  class="col-sm-2 col-form-label">আবেদনকারীর নাম </label>
                        <label  class="col-sm-3 col-form-label">: {{data.user.name}}</label>

                        <label  class="col-sm-2 col-form-label">বাবা/স্বামীর নাম</label>
                        <label  class="col-sm-3 col-form-label">: {{data.fathers_or_husband_name}}</label>
                    </div>
                    <div  class="form-group row">
                        <label  class="col-sm-2 col-form-label"> মায়ের নাম </label>
                        <label  class="col-sm-3 col-form-label">: {{data.mothers_name}}</label>
<!--                        <div class="col-sm-2"></div>-->
                        <label  class="col-sm-2 col-form-label">রাস্তার নাম</label>
                        <label  class="col-sm-3 col-form-label">: {{data.road_name}}</label>
                    </div>
                    <div  class="form-group row">
                        <label  class="col-sm-2 col-form-label">মহল্লার নাম  </label>
                        <label  class="col-sm-3 col-form-label">: {{data.moholla_name}}</label>
<!--                        <div class="col-sm-2"></div>-->
                        <label  class="col-sm-2 col-form-label">বাড়ির ধরন</label>
                        <label  class="col-sm-3 col-form-label">: {{data.home_type}}</label>
                    </div>
                    <div  class="form-group row">
                        <label  class="col-sm-2 col-form-label">ইমারাত নাম্বার  </label>
                        <label  class="col-sm-3 col-form-label">: {{data.imarat_number}}</label>
<!--                        <div class="col-sm-2"></div>-->
                        <label  class="col-sm-2 col-form-label">পরিবার সংখ্যা</label>
                        <label  class="col-sm-3 col-form-label">: {{data.family_number}}</label>
                    </div>
                    <div  class="form-group row">
                        <label  class="col-sm-2 col-form-label">পানির লাইন পরিবর্তনের কারন  </label>
                        <label  class="col-sm-3 col-form-label">: {{data.water_line_change_reason}}</label>
<!--                        <div class="col-sm-2"></div>-->
                        <label  class="col-sm-2 col-form-label">পৌর কর</label>
                        <label  class="col-sm-3 col-form-label">: {{data.paura_tax}}</label>
                    </div>
                    <div  class="form-group row">
                        <label  class="col-sm-2 col-form-label"> পৌর কর  পরিশোধ এর তারিখ </label>
                        <label  class="col-sm-3 col-form-label">: {{data.tax_pay_date}}</label>
<!--                        <div class="col-sm-2"></div>-->
                        <label  class="col-sm-2 col-form-label">হোল্ডিং এর নাম</label>
                        <label v-if="data.holding"  class="col-sm-3 col-form-label">: {{data.holding.bn_name}}</label>
                    </div>
                    <div  class="form-group row">
                        <!--                    <label  class="col-sm-2 col-form-label">সংযোগের ধরন</label>-->
                        <!--                    <label  class="col-sm-3 col-form-label">: {{data.service.name}}</label>-->
                        <label  class="col-sm-2 col-form-label">সংশ্লিষ্ট ওয়ার্ড কাউন্সিলর এর মন্তব্য</label>
                        <label  class="col-sm-3 col-form-label">: {{data.word_counsil_comment}}</label>
<!--                        <div class="col-sm-2"></div>-->
                        <label  class="col-sm-2 col-form-label">মাসিক বিল</label>
                        <label  class="col-sm-3 col-form-label">: {{data.service.price}}</label>
                    </div>

                    <div  class="form-group row">
                        <label v-if="type == 'new-water-ofc-connection'"  class="col-sm-2 col-form-label">সংযোগ ফি</label>
                        <label v-if="type == 'update-water-ofc-connection'" class="col-sm-2 col-form-label">হালনাগাদ ফি</label>
                        <label v-if="type == 'new-water-ofc-connection'" class="col-sm-3 col-form-label">: {{data.service.connection_fee}}</label>
                        <label v-if="type == 'update-water-ofc-connection'" class="col-sm-3 col-form-label">: {{data.service.update_fee}}</label>
<!--                        <div v-if="type == 'update-water-connection' || type == 'new-water-connection'" class="col-sm-2"></div>-->
                        <label v-if="type == 'update-water-ofc-connection' || type == 'new-water-ofc-connection'" class="col-sm-2 col-form-label">অ্যাডজাস্টমেন্ট</label>
                        <label v-if="type == 'update-water-ofc-connection' || type == 'new-water-ofc-connection'"  class="col-sm-3 col-form-label">: {{data.adjustment}}</label>
                    </div>
                    <div  class="form-group row">
                        <label v-if="$user.type == 1" class="col-sm-2 col-form-label">অনুমোদন ডকুমেন্ট</label>
                        <div v-if="data.confirm_3 != 1 && $user.type == 1  && priority == 3" class="col-sm-3">
                            <input
                                    type="file"
                                    ref="ImageFile"
                                    class="file-input"
                                    v-on:change="imageChanged"
                            />
                            <p v-show="check"  style="color:red">* File is required</p>
                        </div>
                        <div v-if="data.confirm_3 == 1 && $user.type == 1" class="col-sm-3">
                            <button @click="downloadFile(data)" class="btn btn-sm btn-primary">Download <i class="fa fa-download" aria-hidden="true"></i></button>
                        </div>
<!--                        <div v-if="$user.type == 1" class="col-sm-2"></div>-->
                        <label  class="col-sm-2 col-form-label">স্ট্যাটাস </label>
                        <label  class="col-sm-3 col-form-label">: <span v-if="data.status == 0">পেন্ডিং</span><span v-if="data.status == 1">অনুমোদিত</span><span v-if="data.status == 2">বাতিল</span></label>
                    </div>
                    <div  class="form-group row">
                        <label  class="col-sm-2 col-form-label">আবেদনকারির স্বাক্ষর</label>
                        <label  class="col-sm-3 col-form-label">: {{data.applicant_sign}}</label>
<!--                        <div class="col-sm-2"></div>-->
                    </div>
                    <div class="form-group row">
                        <div style="border-top:1px solid #888" class="col-sm-12">
                            <br>
                            <div class="pull-right">
                                <p v-if="type == 'new-water-ofc-connection'">মোট ফি<b>: {{data.service.connection_fee + data.adjustment}}</b></p>
                                <p v-if="type == 'update-water-ofc-connection'">মোট ফি<b>: {{data.service.update_fee + data.adjustment}}</b></p>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div v-if="data.confirm_1 && priority == 1" class="form-group row">
                        <div class="col-sm-12">
                            <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                        </div>
                    </div>
                    <div v-if="data.confirm_2 && priority == 2" class="form-group row">
                        <div class="col-sm-12">
                            <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                        </div>
                    </div>
                    <div v-if="data.confirm_3 && priority == 3" class="form-group row">
                        <div class="col-sm-12">
                            <button v-if="!addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                        </div>
                    </div>
                    <div v-if="$user.type == 2" class="form-group row">
                        <div class="col-sm-12">
                            <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                        </div>
                    </div>

                    <div  v-if="!data.confirm_1 && priority == 1" class="form-group row">
                        <div class="col-sm-12">
                            <input type="submit" value="Approve" v-if="!addApplicationLoader"  class="btn btn-primary pull-right">
                            <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                            <button v-if="addApplicationLoader" class="btn btn-primary pull-right" type="button" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Submitting...
                            </button>
                        </div>
                    </div>
                    <div  v-if="!data.confirm_2 && priority == 2" class="form-group row">
                        <div class="col-sm-12">
                            <input type="submit" value="Approve" v-if="!addApplicationLoader"  class="btn btn-primary pull-right">
                            <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                            <button v-if="addApplicationLoader" class="btn btn-primary pull-right" type="button" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Submitting...
                            </button>
                        </div>
                    </div>
                    <div  v-if="!data.confirm_3 && priority == 3" class="form-group row">
                        <div class="col-sm-12">
                            <input type="submit" value="Approve" v-if="!addApplicationLoader"  class="btn btn-primary pull-right">
                            <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                            <button v-if="addApplicationLoader" class="btn btn-primary pull-right" type="button" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Submitting...
                            </button>
                        </div>
                    </div>
                </form>
            </div>

        </b-modal>
        </div>
    </div>
</template>

<script>
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
import axios from 'axios'
import Vue from 'vue'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate)
import { ADD_APPLICATION,UPDATE_APPLICATION} from "@/store/action.type"
export default {
    props:['my_title','type'],
    data(){
        return{
            question:0,
            servererrors:{},
            addApplicationLoader:false,
            index:'',
            largeModal:false,
            data:{
                service:{},
                holding:{},
                user:{}
            },
            check:false,
            application:{
                file:'',
                not_edit_file:10
            },
            user:{

            },
            mySteps:[],
            currentStep:0,
            myStep:0,
            priority:this.$user.permission.priority,
            status:false
        }
    },
    methods:{
        downloadFile(data){
            window.open(axios.defaults.baseURL+'/application/'+data.file)
        },
        imageChanged(e) {
            var fileReader = new FileReader()
            fileReader.readAsDataURL(e.target.files[0])
            fileReader.onload = e => {
                this.application.file = e.target.result
                this.application.not_edit_file = 11
            }
            this.check = false
            // this.url = URL.createObjectURL(e.target.files[0])
        },
        openModal(data,key,statuses,user){
            //console.log(data)
            this.largeModal = true
            this.data = data
            this.user = user
            this.index = key
            this.mySteps = statuses
            //console.log(type)

            if(data.confirm_1){
                this.currentStep = 3;
            }
            else if(data.confirm_2){
                this.currentStep = 2;
            }
            else if(data.confirm_3){
                this.currentStep = 1;
            }else{
                this.currentStep = 0;
            }
        },
        errorClear(fields)
        {
            delete this.servererrors[fields];
        },
        close(){
            this.largeModal = false
        },
        printDoc(el){
            var printContents = document.getElementById(el).innerHTML
            var originalContents = document.body.innerHTML
            document.body.innerHTML = printContents
            window.print();
            document.body.innerHTML = originalContents
        },
        addApplication () {
            if(this.priority == 1 || this.priority == 2){
                this.application.file = true
            }
            //console.log(this.data)
            var data = {

                id:this.data.id,
                user_id:this.data.user.id,
                fee: this.type == 'new-water-ofc-connection'? (this.data.service.connection_fee + this.data.adjustment) : (this.data.service.update_fee + this.data.adjustment),
                type: this.type,
                file: this.application.file,
                account_id:this.data.application?this.data.application.id:"",
                service_id:this.data.service.id,
                pre_service_id: this.data.application? this.data.application.service_id : this.data.service.id,
                not_edit_file: this.data.status == 1 ? this.application.not_edit_file : 10,
                confirm_1:this.priority == 1?1:'',
                confirm_2:this.priority == 2?1:'',
                confirm_3:this.priority == 3?1:'',
            }
            //console.log(this.data)
            var index = this.index

            this.check = true
            this.$validator.validateAll().then( result =>{
                if(result && this.application.file){
                    this.check = false
                    this.addApplicationLoader = true;
                    this.$store.dispatch('UPDATE_APPLICATION',{data,index})
                    .then(response=>{
                        this.addApplicationLoader=false;
                        this.largeModal = false
                    })
                    .catch(error=>{
                        this.addApplicationLoader=false;
                        this.servererrors = error.response.data.errors;
                    });
                }

            })

        },
    },
    computed:{

    },
    components: {
        'step-progress': StepProgress
    },
}
</script>

<style>
.custom_modal_body{
    overflow: auto;
    min-height: 380px;
}
.myDiv{
    position: fixed;
    top: 50% !important;
    left: 50%;
}

.step-progress__step:after {
    height: 40px !important;
    width: 40px !important;
}
.step-progress__step-icon{
    font-size: 15px;
}
.step-progress__step span{
    font-size: 20px;
}
</style>
